import React, { useEffect } from "react";
import { Stack } from "@mui/material";
import FilterText from "../FilterText";
import { IFilter } from "../../../../types/filter.type";

function FilterCustomer({ load, filter, setFilter }: IFilter) {
  const defaultFilter = {
    ma_kh: "",
    ten_kh: "",
    email: "",
    dien_thoai: "",
    ten_nh_kh: "",
  };

  useEffect(() => {
    setFilter(defaultFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [load]);

  return (
    <Stack sx={{ width: "100%" }} gap={2}>
      <FilterText
        label="Mã khách"
        placeholder="Tìm theo mã khách hàng"
        defaultValue={filter.ma_kh}
        onChange={(val) => setFilter({ ...filter, ma_kh: val })}
      />
      <FilterText
        label="Tên khách"
        placeholder="Tìm theo tên khách hàng"
        defaultValue={filter.ten_kh}
        onChange={(val) => setFilter({ ...filter, ten_kh: val })}
      />
      <FilterText
        label="Email"
        placeholder="Tìm theo email khách hàng"
        defaultValue={filter.email}
        onChange={(val) => setFilter({ ...filter, email: val })}
      />
      <FilterText
        label="Điện thoại"
        placeholder="Tìm theo điện thoại khách hàng"
        defaultValue={filter.dien_thoai}
        onChange={(val) => setFilter({ ...filter, dien_thoai: val })}
      />
      <FilterText
        label="Nhóm khách"
        placeholder="Tìm theo nhóm khách hàng"
        defaultValue={filter.ten_nh_kh}
        onChange={(val) => setFilter({ ...filter, ten_nh_kh: val })}
      />
    </Stack>
  );
}

export default FilterCustomer;
